import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('File Name', 'fileName'),
        new NumberColumn('Record No', 'recordNumber'),
        new TextColumn('Error description', 'errorDescription'),
      ],
    },
  ];
};
